// Past the face gallery (body gallery, edit, result) the gallery's own renewal is unmounted, so the editing hold
// would lapse after its 105 s server lease even while the guest keeps working. Wired once in App.js EventWrapper:
// ONE listener for those pages (kept across body -> edit -> result), renewing through the shared owner
// (claimRenewal.js) on real pointerdown / touchstart / keydown only. Its capture listener is registered after the
// flow hook's, so an expiring tap is latched (and the token released) before this runs.
//
// Replies: 410 claim_revoked (operator release) returns the guest Home exactly like the other observed revocations.
// Any other refusal only stops renewing that token; the approve's own answer keeps its existing handling.
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getFaceClaimEvent } from "./faceClaimEvent";
import { renewStoredHold } from "./claimRenewal";
import { returnHomeAfterAdminRelease, WATCHED_PAGES } from "./adminRelease";

const ACTIVITY_EVENTS = ["pointerdown", "touchstart", "keydown"];

export const useClaimRenewal = ({ enabled, page }) => {
  const navigate = useNavigate();
  const watched = Boolean(enabled) && WATCHED_PAGES.includes(page);

  useEffect(() => {
    if (!watched) return undefined;
    const event = getFaceClaimEvent();
    if (!event) return undefined;
    let disposed = false;

    const onActivity = async () => {
      if (disposed) return;
      const outcome = await renewStoredHold(event);
      if (disposed || !outcome) return;
      const { result } = outcome;
      if (result.status === 410 && result.code === "claim_revoked") returnHomeAfterAdminRelease(navigate);
    };

    ACTIVITY_EVENTS.forEach((name) =>
      window.addEventListener(name, onActivity, { capture: true, passive: true })
    );
    return () => {
      disposed = true;
      ACTIVITY_EVENTS.forEach((name) =>
        window.removeEventListener(name, onActivity, { capture: true })
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watched]);
};
